import { render, staticRenderFns } from "./doctorIP.vue?vue&type=template&id=fa976420&scoped=true&"
import script from "./doctorIP.vue?vue&type=script&lang=js&"
export * from "./doctorIP.vue?vue&type=script&lang=js&"
import style0 from "./doctorIP.vue?vue&type=style&index=0&id=fa976420&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa976420",
  null
  
)

export default component.exports